<template>
  <PrivacySection title="4. Base Giuridica e Finalità del Trattamento">
    <p>
      Trattiamo i dati personali per le seguenti finalità e sulla base delle seguenti 
      basi giuridiche:
    </p>
    
    <PrivacySubsection title="4.1 Esecuzione del Contratto">
      <ul>
        <li>Fornire l'accesso al servizio della Lotteria degli Scontrini tramite 
            l'applicazione mobile</li>
        <li>Permettere la generazione e la memorizzazione del codice lotteria</li>
        <li>Garantire il corretto funzionamento del sito web e dell'applicazione</li>
      </ul>
    </PrivacySubsection>

    <PrivacySubsection title="4.2 Consenso dell'Interessato">
      <ul>
        <li>Rispondere alle richieste inviate tramite il modulo di contatto</li>
        <li>Inviare comunicazioni informative (solo previo consenso esplicito)</li>
      </ul>
    </PrivacySubsection>

    <PrivacySubsection title="4.3 Legittimo Interesse">
      <ul>
        <li>Migliorare i nostri Servizi e l'esperienza utente</li>
        <li>Garantire la sicurezza e prevenire frodi</li>
        <li>Analizzare l'utilizzo dei Servizi per scopi statistici e di miglioramento</li>
      </ul>
    </PrivacySubsection>

    <PrivacySubsection title="4.4 Obbligo di Legge">
      <ul>
        <li>Adempiere agli obblighi di legge, regolamentari o amministrativi</li>
        <li>Rispondere a richieste delle autorità competenti</li>
      </ul>
    </PrivacySubsection>
  </PrivacySection>
</template>

<script>
import PrivacySection from '../PrivacySection.vue'
import PrivacySubsection from '../PrivacySubsection.vue'

export default {
  name: 'LegalBasisSection',
  components: {
    PrivacySection,
    PrivacySubsection
  }
}
</script>

